/* oxlint-disable no-underscore-dangle */

import { PostMessage, RequestMessageTransportResult } from './type';

export function webkitGlobalMessageHandlerExists(): boolean {
  return Boolean(window.webkit?.messageHandlers?.webViewBridge);
}

async function webkitGlobalPostMessage(outgoingMessage: string): Promise<string> {
  return (await window.webkit?.messageHandlers?.webViewBridge?.postMessage(outgoingMessage)) as string;
}

export async function webkitPostMessage<T>(sessionId: string, outgoingMessage: T) {
  await webkitGlobalPostMessage(
    JSON.stringify({
      command: 'message',
      message: outgoingMessage,
      sessionId,
    }),
  );
}

export async function webkitRequestMessageTransport<HostMetadata, GuestMetadata>(
  channelName: string,
  metadata: GuestMetadata,
): Promise<RequestMessageTransportResult<HostMetadata>> {
  const result = await webkitGlobalPostMessage(
    JSON.stringify({
      command: 'requestMessageTransport',
      channelName,
      metadata,
    }),
  );
  return JSON.parse(result) as RequestMessageTransportResult<HostMetadata>;
}

export async function webkitCloseMessageTransport(channelName: string, sessionId: string) {
  await webkitGlobalPostMessage(
    JSON.stringify({
      command: 'closeMessageTransport',
      channelName,
      sessionId,
    }),
  );
}

interface iOSPrexSimpleBridge {
  postMessage: (message: Record<string, unknown>) => void;
}

interface WebkitMessageHandler {
  postMessage: PostMessage<string>;
}

interface WebkitMessageHandlers {
  WebviewHandler: WebkitMessageHandler; // Deprecated
  webViewBridge?: WebkitMessageHandler;
  iOSPrexSimpleBridge?: iOSPrexSimpleBridge;
}

interface Webkit {
  messageHandlers?: WebkitMessageHandlers;
}

declare global {
  interface Window {
    webkit?: Webkit;
  }
}
